"use strict";

//Parallax code du prof

const layers = document.querySelectorAll(".parallax__el");

function parallax(){
    
    const scrollTop = window.pageYOffset;

    for(let layer of layers){
        const speed = layer.getAttribute("data-speed");
        const yPos = scrollTop * speed / 100;
        layer.style.transform = "translate3d(0px, " + yPos + "px, 0px)";
    }
}

window.addEventListener("scroll", parallax);

/* MENU code du cours */

const menuToggle = document.querySelector('.menu__toggle');
const menu = document.querySelector('.menu');
const menuLinks = document.querySelectorAll('.menu__el a');

if( menuToggle){
    // Click sur le bouton
    menuToggle.addEventListener('click', menuOpen);

    // Click sur un lien du menu
    for (let i = 0; i < menuLinks.length; i++) {
    menuLinks[i].addEventListener('click', menuOpen);
    menu.classList.remove('menu--open');
}

}

//MENU tuto YTB https://www.youtube.com/watch?v=JEBgqbZWYIQ
 let lastScroll = 0;

const navbar = document.getElementById("navbar");

window.addEventListener("scroll", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > lastScroll) {
        navbar.style.top = "-80px";
       
    } else {
        
        navbar.style.top = "0";
    }

    lastScroll = scrollTop;
});


// Fonction d'ouverture/fermeture du menu
function menuOpen(){
    menu.classList.toggle('menu--open');
}


//BACK TO TOP /code du cours




const backToTop = document.querySelector(".backToTop"); 
window.addEventListener("scroll", showBackToTop); 
if(backToTop) { 
    window.addEventListener("scroll", showBackToTop); 
} 
function showBackToTop() { 
    const currentScroll = window.scrollY; 
    if(currentScroll > 900) { backToTop.classList.add("backToTop--show"); 
        } else{ 
            backToTop.classList.remove("backToTop--show"); 
    } }

/* FOOTER BAR */

const line = document.querySelector(".line__apparition");

if (line) {
    const observer = new IntersectionObserver(onView, {
        threshold: 0.2
    });

    observer.observe(line);
}

function onView(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            line.style.setProperty("--line-width", "100%");
        } else {
            line.style.setProperty("--line-width", "0%");
        }
    });
}

/* SYSTEME DE TAB / Code Du Cours*/

const tabLinks = document.querySelectorAll('.tab__el a');

if (tabLinks) {
    for(let tablink of tabLinks){
        tablink.addEventListener('click', tabTrigger);
    }
}

function tabTrigger(event){
    event.preventDefault();
    const activeLink = document.querySelector('.tab__el--active');
    activeLink.classList.remove('tab__el--active');
    event.currentTarget.parentNode.classList.add('tab__el--active');
    
    const activeTab = document.querySelector('.tab__content--active');
    activeTab.classList.remove('tab__content--active');
    
    const tabSelectId = event.currentTarget.getAttribute('href');
    const tabSelect = document.querySelector(tabSelectId);
    tabSelect.classList.add('tab__content--active');

 }

/*  TRANSITION PAGE /CODE COURS */

    var links = document.querySelectorAll(".el__lien");
    var bloc2 = document.querySelector(".bloc2");

    links.forEach(function (link) {
    link.addEventListener("click", pageTransition);
    });

    function pageTransition(e) {
    e.preventDefault();

    var linkHref = this.href;

    document.body.classList.add("pageAnimation");

    bloc2.addEventListener(
        "animationend",
        function () {
        window.location = linkHref;
        },
        { once: true }
    );
    }


    /* GRENOUILLE / code cours ILabs */
var containerGrenouille = document.getElementById("grenouille");
if (containerGrenouille) {
    var animGrenouille = lottie.loadAnimation({
      container: containerGrenouille,
      renderer: "svg",
      autoplay: true,
      path: "./assets/images/grenouille01.json"
    });

    containerGrenouille.addEventListener("mouseenter", function() {
      animGrenouille.pause();
    });

    containerGrenouille.addEventListener("mouseleave", function() {
      animGrenouille.play();
    });
}


/* ARAIGNÉE */
var containerAraignee = document.getElementById("araignee");
if (containerAraignee) {
    var animAraignee = lottie.loadAnimation({
      container: containerAraignee,
      renderer: "svg",
      autoplay: true,
      path: "./assets/images/araigne.json"
    });

    containerAraignee.addEventListener("mouseenter", function() {
      animAraignee.pause();
    });

    containerAraignee.addEventListener("mouseleave", function() {
      animAraignee.play();
    });
}


/* SLIME */
var containerSlime = document.getElementById("slime");
if (containerSlime) {
    var animSlime = lottie.loadAnimation({
      container: containerSlime,
      renderer: "svg",
      autoplay: true,
      path: "./assets/images/slime.json"
    });

    containerSlime.addEventListener("mouseenter", function() {
      animSlime.pause();
    });

    containerSlime.addEventListener("mouseleave", function() {
      animSlime.play();
    });
}


